// extracted by mini-css-extract-plugin
export default {"copy":"AdMessage_copy__kXSBB","messageBox":"AdMessage_messageBox__sYbtC","left":"AdMessage_left__IG-v6","seeMore":"AdMessage_seeMore__mB+Xa","message":"AdMessage_message__uSH7-"};